const getPosition = (input: HTMLInputElement | null) => input?.selectionStart || 0;

function setPosition(elem: HTMLInputElement | null, position: number) {
	if (!elem) return;

	// Timeout need for correct work in Safari
	setTimeout(() => {
		elem.focus();
		elem.setSelectionRange(position, position);
	});
}

export const cursor = {getPosition, setPosition};
